import * as Sentry from "@sentry/react";
import { env } from "./env";
import React from "react";
import { createRoot } from "react-dom/client";
import "~/index.css";
import { PosconStage } from "@poscon/shared-frontend";
import { store } from "~redux/store";
import { Provider } from "react-redux";
import { Edst } from "~/Edst";
import { Assets } from "pixi.js";

Sentry.init({
  dsn: env.VITE_SENTRY_URL_EDST,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.browserProfilingIntegration(),
  ],
  sampleRate: 1,
  // Tracing
  tracesSampleRate: 0.001,
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["hq.poscon.local", "https://nas.poscon.net"],
  // Set profilesSampleRate to 1.0 to profile every transaction.
  // Since profilesSampleRate is relative to tracesSampleRate,
  // the final profiling rate can be computed as tracesSampleRate * profilesSampleRate
  // For example, a tracesSampleRate of 0.5 and profilesSampleRate of 0.5 would
  // results in 25% of transactions being profiled (0.5*0.5=0.25)
  profilesSampleRate: 0.1,
});

await Assets.load([
  "/fonts/eramCpdlc1.xml",
  "/fonts/eramCpdlc2.xml",
  "/fonts/eramCpdlc3.xml",
  "/fonts/eramCpdlc4.xml",
  "/fonts/eramCpdlc5.xml",
  "/fonts/edstText2.xml",
  "/fonts/eramText1.xml",
  "/fonts/eramText2.xml",
  "/fonts/eramText3.xml",
  "/fonts/eramText4.xml",
  "/fonts/eramText5.xml",
  "/fonts/eramText6.xml",
  "/fonts/eramText7.xml",
  "/fonts/eramText8.xml",
  "/fonts/eramGeomapSymbols1.xml",
  "/fonts/eramGeomapSymbols2.xml",
  "/fonts/eramGeomapSymbols3.xml",
  "/fonts/eramGeomapSymbols4.xml",
  "/fonts/eramPositionSymbols1.xml",
  "/fonts/eramTargetSymbols1.xml",
]);

const container = document.getElementById("root");
const root = createRoot(container!); // createRoot(container!) if you use TypeScript
root.render(
  <React.StrictMode>
    <div id="edstRoot" className="root" onContextMenu={(e) => e.preventDefault()}>
      <PosconStage>
        <Provider store={store}>
          <Edst />
        </Provider>
      </PosconStage>
    </div>
  </React.StrictMode>,
);
